(window["webpackJsonpUtilityHeader"] = window["webpackJsonpUtilityHeader"] || []).push([["vendors~browser-deprecation-banner"],{

/***/ "./node_modules/@ux/browser-deprecation-banner/src/index.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/@ux/browser-deprecation-banner/src/index.js + 10 modules ***!
  \*******************************************************************************/
/*! exports provided: default */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@babel/runtime/helpers/defineProperty.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","intl"],"commonjs":["react-intl","default"],"commonjs2":["react-intl","default"],"amd":"react-intl"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","trfq"],"commonjs":["react-trfq","default"],"commonjs2":["react-trfq","default"],"amd":"react-trfq"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"} (<- Module is not an ECMAScript module) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ BannerLoader; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("./node_modules/@babel/runtime/helpers/defineProperty.js");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"}
var external_root_React_commonjs_react_commonjs2_react_amd_react_ = __webpack_require__("react");
var external_root_React_commonjs_react_commonjs2_react_amd_react_default = /*#__PURE__*/__webpack_require__.n(external_root_React_commonjs_react_commonjs2_react_amd_react_);

// EXTERNAL MODULE: external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"}
var external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_ = __webpack_require__("prop-types");
var external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_);

// EXTERNAL MODULE: external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"}
var namespace_component_ = __webpack_require__("@ux/namespace-component");

// EXTERNAL MODULE: external {"root":["ux","intl"],"commonjs":["react-intl","default"],"commonjs2":["react-intl","default"],"amd":"react-intl"}
var external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_ = __webpack_require__("react-intl");

// CONCATENATED MODULE: ./node_modules/bowser/src/constants.js
// NOTE: this list must be up-to-date with browsers listed in
// test/acceptance/useragentstrings.yml
const BROWSER_ALIASES_MAP = {
  'Amazon Silk': 'amazon_silk',
  'Android Browser': 'android',
  Bada: 'bada',
  BlackBerry: 'blackberry',
  Chrome: 'chrome',
  Chromium: 'chromium',
  Electron: 'electron',
  Epiphany: 'epiphany',
  Firefox: 'firefox',
  Focus: 'focus',
  Generic: 'generic',
  'Google Search': 'google_search',
  Googlebot: 'googlebot',
  'Internet Explorer': 'ie',
  'K-Meleon': 'k_meleon',
  Maxthon: 'maxthon',
  'Microsoft Edge': 'edge',
  'MZ Browser': 'mz',
  'NAVER Whale Browser': 'naver',
  Opera: 'opera',
  'Opera Coast': 'opera_coast',
  PhantomJS: 'phantomjs',
  Puffin: 'puffin',
  QupZilla: 'qupzilla',
  QQ: 'qq',
  QQLite: 'qqlite',
  Safari: 'safari',
  Sailfish: 'sailfish',
  'Samsung Internet for Android': 'samsung_internet',
  SeaMonkey: 'seamonkey',
  Sleipnir: 'sleipnir',
  Swing: 'swing',
  Tizen: 'tizen',
  'UC Browser': 'uc',
  Vivaldi: 'vivaldi',
  'WebOS Browser': 'webos',
  WeChat: 'wechat',
  'Yandex Browser': 'yandex',
  Roku: 'roku'
};
const BROWSER_MAP = {
  amazon_silk: 'Amazon Silk',
  android: 'Android Browser',
  bada: 'Bada',
  blackberry: 'BlackBerry',
  chrome: 'Chrome',
  chromium: 'Chromium',
  electron: 'Electron',
  epiphany: 'Epiphany',
  firefox: 'Firefox',
  focus: 'Focus',
  generic: 'Generic',
  googlebot: 'Googlebot',
  google_search: 'Google Search',
  ie: 'Internet Explorer',
  k_meleon: 'K-Meleon',
  maxthon: 'Maxthon',
  edge: 'Microsoft Edge',
  mz: 'MZ Browser',
  naver: 'NAVER Whale Browser',
  opera: 'Opera',
  opera_coast: 'Opera Coast',
  phantomjs: 'PhantomJS',
  puffin: 'Puffin',
  qupzilla: 'QupZilla',
  qq: 'QQ Browser',
  qqlite: 'QQ Browser Lite',
  safari: 'Safari',
  sailfish: 'Sailfish',
  samsung_internet: 'Samsung Internet for Android',
  seamonkey: 'SeaMonkey',
  sleipnir: 'Sleipnir',
  swing: 'Swing',
  tizen: 'Tizen',
  uc: 'UC Browser',
  vivaldi: 'Vivaldi',
  webos: 'WebOS Browser',
  wechat: 'WeChat',
  yandex: 'Yandex Browser'
};
const PLATFORMS_MAP = {
  tablet: 'tablet',
  mobile: 'mobile',
  desktop: 'desktop',
  tv: 'tv'
};
const OS_MAP = {
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MacOS: 'macOS',
  iOS: 'iOS',
  Android: 'Android',
  WebOS: 'WebOS',
  BlackBerry: 'BlackBerry',
  Bada: 'Bada',
  Tizen: 'Tizen',
  Linux: 'Linux',
  ChromeOS: 'Chrome OS',
  PlayStation4: 'PlayStation 4',
  Roku: 'Roku'
};
const ENGINE_MAP = {
  EdgeHTML: 'EdgeHTML',
  Blink: 'Blink',
  Trident: 'Trident',
  Presto: 'Presto',
  Gecko: 'Gecko',
  WebKit: 'WebKit'
};
// CONCATENATED MODULE: ./node_modules/bowser/src/utils.js

class utils_Utils {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(regexp, ua) {
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */


  static getSecondMatch(regexp, ua) {
    const match = ua.match(regexp);
    return match && match.length > 1 && match[2] || '';
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */


  static matchAndReturnConst(regexp, ua, _const) {
    if (regexp.test(ua)) {
      return _const;
    }

    return void 0;
  }

  static getWindowsVersionName(version) {
    switch (version) {
      case 'NT':
        return 'NT';

      case 'XP':
        return 'XP';

      case 'NT 5.0':
        return '2000';

      case 'NT 5.1':
        return 'XP';

      case 'NT 5.2':
        return '2003';

      case 'NT 6.0':
        return 'Vista';

      case 'NT 6.1':
        return '7';

      case 'NT 6.2':
        return '8';

      case 'NT 6.3':
        return '8.1';

      case 'NT 10.0':
        return '10';

      default:
        return undefined;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */


  static getMacOSVersionName(version) {
    const v = version.split('.').splice(0, 2).map(s => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] !== 10) return undefined;

    switch (v[1]) {
      case 5:
        return 'Leopard';

      case 6:
        return 'Snow Leopard';

      case 7:
        return 'Lion';

      case 8:
        return 'Mountain Lion';

      case 9:
        return 'Mavericks';

      case 10:
        return 'Yosemite';

      case 11:
        return 'El Capitan';

      case 12:
        return 'Sierra';

      case 13:
        return 'High Sierra';

      case 14:
        return 'Mojave';

      case 15:
        return 'Catalina';

      default:
        return undefined;
    }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */


  static getAndroidVersionName(version) {
    const v = version.split('.').splice(0, 2).map(s => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] === 1 && v[1] < 5) return undefined;
    if (v[0] === 1 && v[1] < 6) return 'Cupcake';
    if (v[0] === 1 && v[1] >= 6) return 'Donut';
    if (v[0] === 2 && v[1] < 2) return 'Eclair';
    if (v[0] === 2 && v[1] === 2) return 'Froyo';
    if (v[0] === 2 && v[1] > 2) return 'Gingerbread';
    if (v[0] === 3) return 'Honeycomb';
    if (v[0] === 4 && v[1] < 1) return 'Ice Cream Sandwich';
    if (v[0] === 4 && v[1] < 4) return 'Jelly Bean';
    if (v[0] === 4 && v[1] >= 4) return 'KitKat';
    if (v[0] === 5) return 'Lollipop';
    if (v[0] === 6) return 'Marshmallow';
    if (v[0] === 7) return 'Nougat';
    if (v[0] === 8) return 'Oreo';
    if (v[0] === 9) return 'Pie';
    return undefined;
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */


  static getVersionPrecision(version) {
    return version.split('.').length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */

  /* eslint consistent-return: 1 */


  static compareVersions(versionA, versionB, isLoose = false) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    const versionAPrecision = utils_Utils.getVersionPrecision(versionA);
    const versionBPrecision = utils_Utils.getVersionPrecision(versionB);
    let precision = Math.max(versionAPrecision, versionBPrecision);
    let lastPrecision = 0;
    const chunks = utils_Utils.map([versionA, versionB], version => {
      const delta = precision - utils_Utils.getVersionPrecision(version); // 2) "9" -> "9.0" (for precision = 2)

      const _version = version + new Array(delta + 1).join('.0'); // 3) "9.0" -> ["000000000"", "000000009"]


      return utils_Utils.map(_version.split('.'), chunk => new Array(20 - chunk.length).join('0') + chunk).reverse();
    }); // adjust precision for loose comparison

    if (isLoose) {
      lastPrecision = precision - Math.min(versionAPrecision, versionBPrecision);
    } // iterate in reverse order by reversed chunks array


    precision -= 1;

    while (precision >= lastPrecision) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }

      if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === lastPrecision) {
          // all version chunks are same
          return 0;
        }

        precision -= 1;
      } else if (chunks[0][precision] < chunks[1][precision]) {
        return -1;
      }
    }

    return undefined;
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */


  static map(arr, iterator) {
    const result = [];
    let i;

    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }

    for (i = 0; i < arr.length; i += 1) {
      result.push(iterator(arr[i]));
    }

    return result;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */


  static find(arr, predicate) {
    let i;
    let l;

    if (Array.prototype.find) {
      return Array.prototype.find.call(arr, predicate);
    }

    for (i = 0, l = arr.length; i < l; i += 1) {
      const value = arr[i];

      if (predicate(value, i)) {
        return value;
      }
    }

    return undefined;
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */


  static assign(obj, ...assigners) {
    const result = obj;
    let i;
    let l;

    if (Object.assign) {
      return Object.assign(obj, ...assigners);
    }

    for (i = 0, l = assigners.length; i < l; i += 1) {
      const assigner = assigners[i];

      if (typeof assigner === 'object' && assigner !== null) {
        const keys = Object.keys(assigner);
        keys.forEach(key => {
          result[key] = assigner[key];
        });
      }
    }

    return obj;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */


  static getBrowserAlias(browserName) {
    return BROWSER_ALIASES_MAP[browserName];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */


  static getBrowserTypeByAlias(browserAlias) {
    return BROWSER_MAP[browserAlias] || '';
  }

}
// CONCATENATED MODULE: ./node_modules/bowser/src/parser-browsers.js
/**
 * Browsers' descriptors
 *
 * The idea of descriptors is simple. You should know about them two simple things:
 * 1. Every descriptor has a method or property called `test` and a `describe` method.
 * 2. Order of descriptors is important.
 *
 * More details:
 * 1. Method or property `test` serves as a way to detect whether the UA string
 * matches some certain browser or not. The `describe` method helps to make a result
 * object with params that show some browser-specific things: name, version, etc.
 * 2. Order of descriptors is important because a Parser goes through them one by one
 * in course. For example, if you insert Chrome's descriptor as the first one,
 * more then a half of browsers will be described as Chrome, because they will pass
 * the Chrome descriptor's test.
 *
 * Descriptor's `test` could be a property with an array of RegExps, where every RegExp
 * will be applied to a UA string to test it whether it matches or not.
 * If a descriptor has two or more regexps in the `test` array it tests them one by one
 * with a logical sum operation. Parser stops if it has found any RegExp that matches the UA.
 *
 * Or `test` could be a method. In that case it gets a Parser instance and should
 * return true/false to get the Parser know if this browser descriptor matches the UA or not.
 */

const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
const browsersList = [
/* Googlebot */
{
  test: [/googlebot/i],

  describe(ua) {
    const browser = {
      name: 'Googlebot'
    };
    const version = utils_Utils.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

},
/* Opera < 13.0 */
{
  test: [/opera/i],

  describe(ua) {
    const browser = {
      name: 'Opera'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

},
/* Opera > 13.0 */
{
  test: [/opr\/|opios/i],

  describe(ua) {
    const browser = {
      name: 'Opera'
    };
    const version = utils_Utils.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/SamsungBrowser/i],

  describe(ua) {
    const browser = {
      name: 'Samsung Internet for Android'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/Whale/i],

  describe(ua) {
    const browser = {
      name: 'NAVER Whale Browser'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/MZBrowser/i],

  describe(ua) {
    const browser = {
      name: 'MZ Browser'
    };
    const version = utils_Utils.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/focus/i],

  describe(ua) {
    const browser = {
      name: 'Focus'
    };
    const version = utils_Utils.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/swing/i],

  describe(ua) {
    const browser = {
      name: 'Swing'
    };
    const version = utils_Utils.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/coast/i],

  describe(ua) {
    const browser = {
      name: 'Opera Coast'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/opt\/\d+(?:.?_?\d+)+/i],

  describe(ua) {
    const browser = {
      name: 'Opera Touch'
    };
    const version = utils_Utils.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/yabrowser/i],

  describe(ua) {
    const browser = {
      name: 'Yandex Browser'
    };
    const version = utils_Utils.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/ucbrowser/i],

  describe(ua) {
    const browser = {
      name: 'UC Browser'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/Maxthon|mxios/i],

  describe(ua) {
    const browser = {
      name: 'Maxthon'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/epiphany/i],

  describe(ua) {
    const browser = {
      name: 'Epiphany'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/puffin/i],

  describe(ua) {
    const browser = {
      name: 'Puffin'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/sleipnir/i],

  describe(ua) {
    const browser = {
      name: 'Sleipnir'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/k-meleon/i],

  describe(ua) {
    const browser = {
      name: 'K-Meleon'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/micromessenger/i],

  describe(ua) {
    const browser = {
      name: 'WeChat'
    };
    const version = utils_Utils.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/qqbrowser/i],

  describe(ua) {
    const browser = {
      name: /qqbrowserlite/i.test(ua) ? 'QQ Browser Lite' : 'QQ Browser'
    };
    const version = utils_Utils.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/msie|trident/i],

  describe(ua) {
    const browser = {
      name: 'Internet Explorer'
    };
    const version = utils_Utils.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/\sedg\//i],

  describe(ua) {
    const browser = {
      name: 'Microsoft Edge'
    };
    const version = utils_Utils.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/edg([ea]|ios)/i],

  describe(ua) {
    const browser = {
      name: 'Microsoft Edge'
    };
    const version = utils_Utils.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/vivaldi/i],

  describe(ua) {
    const browser = {
      name: 'Vivaldi'
    };
    const version = utils_Utils.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/seamonkey/i],

  describe(ua) {
    const browser = {
      name: 'SeaMonkey'
    };
    const version = utils_Utils.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/sailfish/i],

  describe(ua) {
    const browser = {
      name: 'Sailfish'
    };
    const version = utils_Utils.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/silk/i],

  describe(ua) {
    const browser = {
      name: 'Amazon Silk'
    };
    const version = utils_Utils.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/phantom/i],

  describe(ua) {
    const browser = {
      name: 'PhantomJS'
    };
    const version = utils_Utils.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/slimerjs/i],

  describe(ua) {
    const browser = {
      name: 'SlimerJS'
    };
    const version = utils_Utils.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/blackberry|\bbb\d+/i, /rim\stablet/i],

  describe(ua) {
    const browser = {
      name: 'BlackBerry'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/(web|hpw)[o0]s/i],

  describe(ua) {
    const browser = {
      name: 'WebOS Browser'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua) || utils_Utils.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/bada/i],

  describe(ua) {
    const browser = {
      name: 'Bada'
    };
    const version = utils_Utils.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/tizen/i],

  describe(ua) {
    const browser = {
      name: 'Tizen'
    };
    const version = utils_Utils.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/qupzilla/i],

  describe(ua) {
    const browser = {
      name: 'QupZilla'
    };
    const version = utils_Utils.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/firefox|iceweasel|fxios/i],

  describe(ua) {
    const browser = {
      name: 'Firefox'
    };
    const version = utils_Utils.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/electron/i],

  describe(ua) {
    const browser = {
      name: 'Electron'
    };
    const version = utils_Utils.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/chromium/i],

  describe(ua) {
    const browser = {
      name: 'Chromium'
    };
    const version = utils_Utils.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, ua) || utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/chrome|crios|crmo/i],

  describe(ua) {
    const browser = {
      name: 'Chrome'
    };
    const version = utils_Utils.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

}, {
  test: [/GSA/i],

  describe(ua) {
    const browser = {
      name: 'Google Search'
    };
    const version = utils_Utils.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

},
/* Android Browser */
{
  test(parser) {
    const notLikeAndroid = !parser.test(/like android/i);
    const butAndroid = parser.test(/android/i);
    return notLikeAndroid && butAndroid;
  },

  describe(ua) {
    const browser = {
      name: 'Android Browser'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

},
/* PlayStation 4 */
{
  test: [/playstation 4/i],

  describe(ua) {
    const browser = {
      name: 'PlayStation 4'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

},
/* Safari */
{
  test: [/safari|applewebkit/i],

  describe(ua) {
    const browser = {
      name: 'Safari'
    };
    const version = utils_Utils.getFirstMatch(commonVersionIdentifier, ua);

    if (version) {
      browser.version = version;
    }

    return browser;
  }

},
/* Something else */
{
  test: [/.*/i],

  describe(ua) {
    /* Here we try to make sure that there are explicit details about the device
     * in order to decide what regexp exactly we want to apply
     * (as there is a specific decision based on that conclusion)
     */
    const regexpWithoutDeviceSpec = /^(.*)\/(.*) /;
    const regexpWithDeviceSpec = /^(.*)\/(.*)[ \t]\((.*)/;
    const hasDeviceSpec = ua.search('\\(') !== -1;
    const regexp = hasDeviceSpec ? regexpWithDeviceSpec : regexpWithoutDeviceSpec;
    return {
      name: utils_Utils.getFirstMatch(regexp, ua),
      version: utils_Utils.getSecondMatch(regexp, ua)
    };
  }

}];
/* harmony default export */ var parser_browsers = (browsersList);
// CONCATENATED MODULE: ./node_modules/bowser/src/parser-os.js


/* harmony default export */ var parser_os = ([
/* Roku */
{
  test: [/Roku\/DVP/],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, ua);
    return {
      name: OS_MAP.Roku,
      version
    };
  }

},
/* Windows Phone */
{
  test: [/windows phone/i],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, ua);
    return {
      name: OS_MAP.WindowsPhone,
      version
    };
  }

},
/* Windows */
{
  test: [/windows /i],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, ua);
    const versionName = utils_Utils.getWindowsVersionName(version);
    return {
      name: OS_MAP.Windows,
      version,
      versionName
    };
  }

},
/* Firefox on iPad */
{
  test: [/Macintosh(.*?) FxiOS(.*?)\//],

  describe(ua) {
    const result = {
      name: OS_MAP.iOS
    };
    const version = utils_Utils.getSecondMatch(/(Version\/)(\d[\d.]+)/, ua);

    if (version) {
      result.version = version;
    }

    return result;
  }

},
/* macOS */
{
  test: [/macintosh/i],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, ua).replace(/[_\s]/g, '.');
    const versionName = utils_Utils.getMacOSVersionName(version);
    const os = {
      name: OS_MAP.MacOS,
      version
    };

    if (versionName) {
      os.versionName = versionName;
    }

    return os;
  }

},
/* iOS */
{
  test: [/(ipod|iphone|ipad)/i],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, ua).replace(/[_\s]/g, '.');
    return {
      name: OS_MAP.iOS,
      version
    };
  }

},
/* Android */
{
  test(parser) {
    const notLikeAndroid = !parser.test(/like android/i);
    const butAndroid = parser.test(/android/i);
    return notLikeAndroid && butAndroid;
  },

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, ua);
    const versionName = utils_Utils.getAndroidVersionName(version);
    const os = {
      name: OS_MAP.Android,
      version
    };

    if (versionName) {
      os.versionName = versionName;
    }

    return os;
  }

},
/* WebOS */
{
  test: [/(web|hpw)[o0]s/i],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, ua);
    const os = {
      name: OS_MAP.WebOS
    };

    if (version && version.length) {
      os.version = version;
    }

    return os;
  }

},
/* BlackBerry */
{
  test: [/blackberry|\bbb\d+/i, /rim\stablet/i],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, ua) || utils_Utils.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, ua) || utils_Utils.getFirstMatch(/\bbb(\d+)/i, ua);
    return {
      name: OS_MAP.BlackBerry,
      version
    };
  }

},
/* Bada */
{
  test: [/bada/i],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, ua);
    return {
      name: OS_MAP.Bada,
      version
    };
  }

},
/* Tizen */
{
  test: [/tizen/i],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, ua);
    return {
      name: OS_MAP.Tizen,
      version
    };
  }

},
/* Linux */
{
  test: [/linux/i],

  describe() {
    return {
      name: OS_MAP.Linux
    };
  }

},
/* Chrome OS */
{
  test: [/CrOS/],

  describe() {
    return {
      name: OS_MAP.ChromeOS
    };
  }

},
/* Playstation 4 */
{
  test: [/PlayStation 4/],

  describe(ua) {
    const version = utils_Utils.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, ua);
    return {
      name: OS_MAP.PlayStation4,
      version
    };
  }

}]);
// CONCATENATED MODULE: ./node_modules/bowser/src/parser-platforms.js


/*
 * Tablets go first since usually they have more specific
 * signs to detect.
 */

/* harmony default export */ var parser_platforms = ([
/* Googlebot */
{
  test: [/googlebot/i],

  describe() {
    return {
      type: 'bot',
      vendor: 'Google'
    };
  }

},
/* Huawei */
{
  test: [/huawei/i],

  describe(ua) {
    const model = utils_Utils.getFirstMatch(/(can-l01)/i, ua) && 'Nova';
    const platform = {
      type: PLATFORMS_MAP.mobile,
      vendor: 'Huawei'
    };

    if (model) {
      platform.model = model;
    }

    return platform;
  }

},
/* Nexus Tablet */
{
  test: [/nexus\s*(?:7|8|9|10).*/i],

  describe() {
    return {
      type: PLATFORMS_MAP.tablet,
      vendor: 'Nexus'
    };
  }

},
/* iPad */
{
  test: [/ipad/i],

  describe() {
    return {
      type: PLATFORMS_MAP.tablet,
      vendor: 'Apple',
      model: 'iPad'
    };
  }

},
/* Firefox on iPad */
{
  test: [/Macintosh(.*?) FxiOS(.*?)\//],

  describe() {
    return {
      type: PLATFORMS_MAP.tablet,
      vendor: 'Apple',
      model: 'iPad'
    };
  }

},
/* Amazon Kindle Fire */
{
  test: [/kftt build/i],

  describe() {
    return {
      type: PLATFORMS_MAP.tablet,
      vendor: 'Amazon',
      model: 'Kindle Fire HD 7'
    };
  }

},
/* Another Amazon Tablet with Silk */
{
  test: [/silk/i],

  describe() {
    return {
      type: PLATFORMS_MAP.tablet,
      vendor: 'Amazon'
    };
  }

},
/* Tablet */
{
  test: [/tablet(?! pc)/i],

  describe() {
    return {
      type: PLATFORMS_MAP.tablet
    };
  }

},
/* iPod/iPhone */
{
  test(parser) {
    const iDevice = parser.test(/ipod|iphone/i);
    const likeIDevice = parser.test(/like (ipod|iphone)/i);
    return iDevice && !likeIDevice;
  },

  describe(ua) {
    const model = utils_Utils.getFirstMatch(/(ipod|iphone)/i, ua);
    return {
      type: PLATFORMS_MAP.mobile,
      vendor: 'Apple',
      model
    };
  }

},
/* Nexus Mobile */
{
  test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],

  describe() {
    return {
      type: PLATFORMS_MAP.mobile,
      vendor: 'Nexus'
    };
  }

},
/* Mobile */
{
  test: [/[^-]mobi/i],

  describe() {
    return {
      type: PLATFORMS_MAP.mobile
    };
  }

},
/* BlackBerry */
{
  test(parser) {
    return parser.getBrowserName(true) === 'blackberry';
  },

  describe() {
    return {
      type: PLATFORMS_MAP.mobile,
      vendor: 'BlackBerry'
    };
  }

},
/* Bada */
{
  test(parser) {
    return parser.getBrowserName(true) === 'bada';
  },

  describe() {
    return {
      type: PLATFORMS_MAP.mobile
    };
  }

},
/* Windows Phone */
{
  test(parser) {
    return parser.getBrowserName() === 'windows phone';
  },

  describe() {
    return {
      type: PLATFORMS_MAP.mobile,
      vendor: 'Microsoft'
    };
  }

},
/* Android Tablet */
{
  test(parser) {
    const osMajorVersion = Number(String(parser.getOSVersion()).split('.')[0]);
    return parser.getOSName(true) === 'android' && osMajorVersion >= 3;
  },

  describe() {
    return {
      type: PLATFORMS_MAP.tablet
    };
  }

},
/* Android Mobile */
{
  test(parser) {
    return parser.getOSName(true) === 'android';
  },

  describe() {
    return {
      type: PLATFORMS_MAP.mobile
    };
  }

},
/* desktop */
{
  test(parser) {
    return parser.getOSName(true) === 'macos';
  },

  describe() {
    return {
      type: PLATFORMS_MAP.desktop,
      vendor: 'Apple'
    };
  }

},
/* Windows */
{
  test(parser) {
    return parser.getOSName(true) === 'windows';
  },

  describe() {
    return {
      type: PLATFORMS_MAP.desktop
    };
  }

},
/* Linux */
{
  test(parser) {
    return parser.getOSName(true) === 'linux';
  },

  describe() {
    return {
      type: PLATFORMS_MAP.desktop
    };
  }

},
/* PlayStation 4 */
{
  test(parser) {
    return parser.getOSName(true) === 'playstation 4';
  },

  describe() {
    return {
      type: PLATFORMS_MAP.tv
    };
  }

},
/* Roku */
{
  test(parser) {
    return parser.getOSName(true) === 'roku';
  },

  describe() {
    return {
      type: PLATFORMS_MAP.tv
    };
  }

}]);
// CONCATENATED MODULE: ./node_modules/bowser/src/parser-engines.js


/*
 * More specific goes first
 */

/* harmony default export */ var parser_engines = ([
/* EdgeHTML */
{
  test(parser) {
    return parser.getBrowserName(true) === 'microsoft edge';
  },

  describe(ua) {
    const isBlinkBased = /\sedg\//i.test(ua); // return blink if it's blink-based one

    if (isBlinkBased) {
      return {
        name: ENGINE_MAP.Blink
      };
    } // otherwise match the version and return EdgeHTML


    const version = utils_Utils.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, ua);
    return {
      name: ENGINE_MAP.EdgeHTML,
      version
    };
  }

},
/* Trident */
{
  test: [/trident/i],

  describe(ua) {
    const engine = {
      name: ENGINE_MAP.Trident
    };
    const version = utils_Utils.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      engine.version = version;
    }

    return engine;
  }

},
/* Presto */
{
  test(parser) {
    return parser.test(/presto/i);
  },

  describe(ua) {
    const engine = {
      name: ENGINE_MAP.Presto
    };
    const version = utils_Utils.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      engine.version = version;
    }

    return engine;
  }

},
/* Gecko */
{
  test(parser) {
    const isGecko = parser.test(/gecko/i);
    const likeGecko = parser.test(/like gecko/i);
    return isGecko && !likeGecko;
  },

  describe(ua) {
    const engine = {
      name: ENGINE_MAP.Gecko
    };
    const version = utils_Utils.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      engine.version = version;
    }

    return engine;
  }

},
/* Blink */
{
  test: [/(apple)?webkit\/537\.36/i],

  describe() {
    return {
      name: ENGINE_MAP.Blink
    };
  }

},
/* WebKit */
{
  test: [/(apple)?webkit/i],

  describe(ua) {
    const engine = {
      name: ENGINE_MAP.WebKit
    };
    const version = utils_Utils.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, ua);

    if (version) {
      engine.version = version;
    }

    return engine;
  }

}]);
// CONCATENATED MODULE: ./node_modules/bowser/src/parser.js





/**
 * The main class that arranges the whole parsing process.
 */

class parser_Parser {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(UA, skipParsing = false) {
    if (UA === void 0 || UA === null || UA === '') {
      throw new Error("UserAgent parameter can't be empty");
    }

    this._ua = UA;
    /**
     * @typedef ParsedResult
     * @property {Object} browser
     * @property {String|undefined} [browser.name]
     * Browser name, like `"Chrome"` or `"Internet Explorer"`
     * @property {String|undefined} [browser.version] Browser version as a String `"12.01.45334.10"`
     * @property {Object} os
     * @property {String|undefined} [os.name] OS name, like `"Windows"` or `"macOS"`
     * @property {String|undefined} [os.version] OS version, like `"NT 5.1"` or `"10.11.1"`
     * @property {String|undefined} [os.versionName] OS name, like `"XP"` or `"High Sierra"`
     * @property {Object} platform
     * @property {String|undefined} [platform.type]
     * platform type, can be either `"desktop"`, `"tablet"` or `"mobile"`
     * @property {String|undefined} [platform.vendor] Vendor of the device,
     * like `"Apple"` or `"Samsung"`
     * @property {String|undefined} [platform.model] Device model,
     * like `"iPhone"` or `"Kindle Fire HD 7"`
     * @property {Object} engine
     * @property {String|undefined} [engine.name]
     * Can be any of this: `WebKit`, `Blink`, `Gecko`, `Trident`, `Presto`, `EdgeHTML`
     * @property {String|undefined} [engine.version] String version of the engine
     */

    this.parsedResult = {};

    if (skipParsing !== true) {
      this.parse();
    }
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */


  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */


  test(regex) {
    return regex.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */


  parseBrowser() {
    this.parsedResult.browser = {};
    const browserDescriptor = utils_Utils.find(parser_browsers, _browser => {
      if (typeof _browser.test === 'function') {
        return _browser.test(this);
      }

      if (_browser.test instanceof Array) {
        return _browser.test.some(condition => this.test(condition));
      }

      throw new Error("Browser's test function is not valid");
    });

    if (browserDescriptor) {
      this.parsedResult.browser = browserDescriptor.describe(this.getUA());
    }

    return this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */


  getBrowser() {
    if (this.parsedResult.browser) {
      return this.parsedResult.browser;
    }

    return this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */


  getBrowserName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getBrowser().name).toLowerCase() || '';
    }

    return this.getBrowser().name || '';
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */


  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */


  getOS() {
    if (this.parsedResult.os) {
      return this.parsedResult.os;
    }

    return this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */


  parseOS() {
    this.parsedResult.os = {};
    const os = utils_Utils.find(parser_os, _os => {
      if (typeof _os.test === 'function') {
        return _os.test(this);
      }

      if (_os.test instanceof Array) {
        return _os.test.some(condition => this.test(condition));
      }

      throw new Error("Browser's test function is not valid");
    });

    if (os) {
      this.parsedResult.os = os.describe(this.getUA());
    }

    return this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */


  getOSName(toLowerCase) {
    const {
      name
    } = this.getOS();

    if (toLowerCase) {
      return String(name).toLowerCase() || '';
    }

    return name || '';
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */


  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */


  getPlatform() {
    if (this.parsedResult.platform) {
      return this.parsedResult.platform;
    }

    return this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */


  getPlatformType(toLowerCase = false) {
    const {
      type
    } = this.getPlatform();

    if (toLowerCase) {
      return String(type).toLowerCase() || '';
    }

    return type || '';
  }
  /**
   * Get parsed platform
   * @return {{}}
   */


  parsePlatform() {
    this.parsedResult.platform = {};
    const platform = utils_Utils.find(parser_platforms, _platform => {
      if (typeof _platform.test === 'function') {
        return _platform.test(this);
      }

      if (_platform.test instanceof Array) {
        return _platform.test.some(condition => this.test(condition));
      }

      throw new Error("Browser's test function is not valid");
    });

    if (platform) {
      this.parsedResult.platform = platform.describe(this.getUA());
    }

    return this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */


  getEngine() {
    if (this.parsedResult.engine) {
      return this.parsedResult.engine;
    }

    return this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */


  getEngineName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getEngine().name).toLowerCase() || '';
    }

    return this.getEngine().name || '';
  }
  /**
   * Get parsed platform
   * @return {{}}
   */


  parseEngine() {
    this.parsedResult.engine = {};
    const engine = utils_Utils.find(parser_engines, _engine => {
      if (typeof _engine.test === 'function') {
        return _engine.test(this);
      }

      if (_engine.test instanceof Array) {
        return _engine.test.some(condition => this.test(condition));
      }

      throw new Error("Browser's test function is not valid");
    });

    if (engine) {
      this.parsedResult.engine = engine.describe(this.getUA());
    }

    return this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   */


  parse() {
    this.parseBrowser();
    this.parseOS();
    this.parsePlatform();
    this.parseEngine();
    return this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */


  getResult() {
    return utils_Utils.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */


  satisfies(checkTree) {
    const platformsAndOSes = {};
    let platformsAndOSCounter = 0;
    const browsers = {};
    let browsersCounter = 0;
    const allDefinitions = Object.keys(checkTree);
    allDefinitions.forEach(key => {
      const currentDefinition = checkTree[key];

      if (typeof currentDefinition === 'string') {
        browsers[key] = currentDefinition;
        browsersCounter += 1;
      } else if (typeof currentDefinition === 'object') {
        platformsAndOSes[key] = currentDefinition;
        platformsAndOSCounter += 1;
      }
    });

    if (platformsAndOSCounter > 0) {
      const platformsAndOSNames = Object.keys(platformsAndOSes);
      const OSMatchingDefinition = utils_Utils.find(platformsAndOSNames, name => this.isOS(name));

      if (OSMatchingDefinition) {
        const osResult = this.satisfies(platformsAndOSes[OSMatchingDefinition]);

        if (osResult !== void 0) {
          return osResult;
        }
      }

      const platformMatchingDefinition = utils_Utils.find(platformsAndOSNames, name => this.isPlatform(name));

      if (platformMatchingDefinition) {
        const platformResult = this.satisfies(platformsAndOSes[platformMatchingDefinition]);

        if (platformResult !== void 0) {
          return platformResult;
        }
      }
    }

    if (browsersCounter > 0) {
      const browserNames = Object.keys(browsers);
      const matchingDefinition = utils_Utils.find(browserNames, name => this.isBrowser(name, true));

      if (matchingDefinition !== void 0) {
        return this.compareVersion(browsers[matchingDefinition]);
      }
    }

    return undefined;
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */


  isBrowser(browserName, includingAlias = false) {
    const defaultBrowserName = this.getBrowserName().toLowerCase();
    let browserNameLower = browserName.toLowerCase();
    const alias = utils_Utils.getBrowserTypeByAlias(browserNameLower);

    if (includingAlias && alias) {
      browserNameLower = alias.toLowerCase();
    }

    return browserNameLower === defaultBrowserName;
  }

  compareVersion(version) {
    let expectedResults = [0];
    let comparableVersion = version;
    let isLoose = false;
    const currentBrowserVersion = this.getBrowserVersion();

    if (typeof currentBrowserVersion !== 'string') {
      return void 0;
    }

    if (version[0] === '>' || version[0] === '<') {
      comparableVersion = version.substr(1);

      if (version[1] === '=') {
        isLoose = true;
        comparableVersion = version.substr(2);
      } else {
        expectedResults = [];
      }

      if (version[0] === '>') {
        expectedResults.push(1);
      } else {
        expectedResults.push(-1);
      }
    } else if (version[0] === '=') {
      comparableVersion = version.substr(1);
    } else if (version[0] === '~') {
      isLoose = true;
      comparableVersion = version.substr(1);
    }

    return expectedResults.indexOf(utils_Utils.compareVersions(currentBrowserVersion, comparableVersion, isLoose)) > -1;
  }

  isOS(osName) {
    return this.getOSName(true) === String(osName).toLowerCase();
  }

  isPlatform(platformType) {
    return this.getPlatformType(true) === String(platformType).toLowerCase();
  }

  isEngine(engineName) {
    return this.getEngineName(true) === String(engineName).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @returns {Boolean}
   */


  is(anything) {
    return this.isBrowser(anything) || this.isOS(anything) || this.isPlatform(anything);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */


  some(anythings = []) {
    return anythings.some(anything => this.is(anything));
  }

}

/* harmony default export */ var parser = (parser_Parser);
// CONCATENATED MODULE: ./node_modules/bowser/src/bowser.js
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */


/**
 * Bowser class.
 * Keep it simple as much as it can be.
 * It's supposed to work with collections of {@link Parser} instances
 * rather then solve one-instance problems.
 * All the one-instance stuff is located in Parser class.
 *
 * @class
 * @classdesc Bowser is a static object, that provides an API to the Parsers
 * @hideconstructor
 */

class bowser_Bowser {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(UA, skipParsing = false) {
    if (typeof UA !== 'string') {
      throw new Error('UserAgent should be a string');
    }

    return new parser(UA, skipParsing);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */


  static parse(UA) {
    return new parser(UA).getResult();
  }

  static get BROWSER_MAP() {
    return BROWSER_MAP;
  }

  static get ENGINE_MAP() {
    return ENGINE_MAP;
  }

  static get OS_MAP() {
    return OS_MAP;
  }

  static get PLATFORMS_MAP() {
    return PLATFORMS_MAP;
  }

}

/* harmony default export */ var bowser = (bowser_Bowser);
// EXTERNAL MODULE: external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"}
var util_ = __webpack_require__("@ux/util");

// CONCATENATED MODULE: ./node_modules/@ux/browser-deprecation-banner/src/enums.js
const enums_browsers = ['Chrome', 'Safari', 'Edge', 'Firefox'];
const breakpoints = ['mobile', 'phablet'];
const browserNormalizations = {
  'Microsoft Edge': 'Edge',
  'Samsung Internet for Android': 'Samsung Internet'
};

// EXTERNAL MODULE: external {"root":["ux","trfq"],"commonjs":["react-trfq","default"],"commonjs2":["react-trfq","default"],"amd":"react-trfq"}
var external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_ = __webpack_require__("react-trfq");
var external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default = /*#__PURE__*/__webpack_require__.n(external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_);

// CONCATENATED MODULE: ./node_modules/@ux/browser-deprecation-banner/src/banner.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









/**
 * A Banner to be displayed if your browser is too old.
 * @type {BrowserDeprecationBanner}
 */

class banner_BrowserDeprecationBanner extends namespace_component_["NamespaceConsumer"] {
  constructor() {
    super(...arguments);
    this.dismiss = this.dismiss.bind(this);
    let name, version, mac;

    if (typeof navigator !== 'object' || !navigator.userAgent) {
      // pretend to be something we support on server side
      // so we don't briefly flash the banner on supported Browsers
      name = 'Chrome';
      version = '99999999999';
      mac = false;
    } else {
      const parsed = bowser.parse(navigator.userAgent);
      this.userAgent = parsed;
      name = parsed.browser.name; // Some browser names differ in the more recent versions of `bowser`, but we don't want to go update config and
      // other code too much. So we normalize here.

      if (name in browserNormalizations) name = browserNormalizations[name];
      version = parsed.browser.version;
      mac = !!parsed.os.name && (!!~parsed.os.name.toLowerCase().indexOf('mac') || !!~parsed.os.name.toLowerCase().indexOf('ios'));
    }

    this.state = {
      mac: !!mac,
      name,
      version,
      dismissed: false
    };
  }
  /**
   * Handle a user clicking the X to permanently dismiss this
   * banner. The "permanence" lasts as long as cookie lasts.
   */


  dismiss() {
    util_["cookie"].set('_dismissedBDF', 'true');
    this.setState({
      dismissed: true
    });
  }
  /**
   * set breakpoint behavior
   */


  componentDidMount() {
    this.breakpoint(...breakpoints);
  }
  /**
   * Whether or not we recognize this browser. If we do not recognize it,
   * we should not make a decision on whether or not to show this banner.
   * @param {String} browser that is being recognized
   * @returns {String} name of browser that is recognized, otherwise ''
   */


  recognizedBrowser(browser) {
    const {
      supportMatrix
    } = this.props;
    const matched = Object.keys(supportMatrix).filter(b => browser.match(b));
    return matched.length > 0 ? matched[0] : '';
  }
  /**
   * Whether the whitelist provided contains the current useragent
   * @returns {Boolean} true if the useragent whitelist contains the current browser
   */


  get userAgentIsWhitelisted() {
    const {
      whitelistedUserAgents
    } = this.props;

    if (typeof navigator === 'object' && navigator.userAgent && whitelistedUserAgents) {
      return whitelistedUserAgents.some(ua => !!navigator.userAgent.match(ua));
    }

    return false;
  }
  /**
   * Whether the blacklist provided contains the browser in question
   * @param {String} browserName that is being tested
   * @param {Number} browserVersion of the browser to check
   * @returns {Boolean} true if the blacklist contains the browser and version specified
   */


  browserIsBlacklisted(browserName, browserVersion) {
    const {
      blacklistedBrowsers
    } = this.props;
    return blacklistedBrowsers.some(({
      browser,
      version
    }) => browser === browserName && version === browserVersion);
  }
  /**
   * Whether the version is at or below the supported matrix threshold
   * @param {String} browserName that is being tested
   * @param {Number} browserVersion of the browser to check
   * @returns {Boolean} true if the browser is at or below the threshold
   */


  isUnsupportedBrowser(browserName, browserVersion) {
    const {
      supportMatrix
    } = this.props;
    let unsupportedBrowser = false;

    if (supportMatrix && browserName) {
      const newestWithBanner = supportMatrix[browserName][0];

      if (newestWithBanner !== null) {
        unsupportedBrowser = browserVersion > parseFloat(newestWithBanner);
      } else {
        unsupportedBrowser = true;
      }
    }

    return unsupportedBrowser;
  }
  /**
   * Determines if the banner should NOT be rendered
   * @returns {Boolean} Whether or not the banner should be shown for the current browser
   */


  shouldNotShowbanner() {
    if (this.userAgentIsWhitelisted) {
      return true;
    }

    const {
      name,
      version,
      dismissed
    } = this.state;
    const {
      supportMatrix,
      disableDeprecationBanner
    } = this.props;
    let market = null; // Prioritize the prop

    if (this.props.market) {
      market = this.props.market; // Get the market from the window if one was not passed as a prop
    } else if (!market && typeof window === 'object' && typeof window.ux === 'object' && typeof window.ux.data === 'object') {
      market = window.ux.data.market;
    }

    if (disableDeprecationBanner || dismissed || !supportMatrix || util_["cookie"].get && util_["cookie"].get('_dismissedBDF')) {
      return true;
    }

    const browser = this.recognizedBrowser(name);

    if (!browser || typeof version === 'undefined') {
      return true;
    }

    if (this.browserIsBlacklisted(browser, parseFloat(version))) {
      return false;
    }

    return this.isUnsupportedBrowser(browser, parseFloat(version));
  }
  /**
   * Given that the current browser is supported, render the docs
   * @returns {React.ReactElement[]} 3 <span> tags that contain recommendations to download
   * Firefox, Chrome, or (Safari/Edge) depending on their OS
   */


  renderBrowsers() {
    const {
      mac,
      name
    } = this.state;
    const {
      messages,
      urls: {
        cdn
      }
    } = this.props;
    const filtered = enums_browsers.filter(b => b !== (mac ? 'Edge' : 'Safari')).sort(a => a !== name ? 1 : 0);
    const get = 'Shared:BrowserDeprecationBanner:GetBrowser';
    const update = 'Shared:BrowserDeprecationBanner:UpdateBrowser';
    return filtered.map(browser => /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: messages["Shared:BrowserDeprecationBanner:Download".concat(browser)],
      className: this.namespace('browser-link'),
      key: "name-".concat(browser)
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("img", {
      alt: browser,
      src: "".concat(cdn.href, "wrhs/browser-deprecation-warning/").concat(browser, ".png"),
      className: this.namespace('browser-icon', browser.toLowerCase())
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('browser-text')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: browser === name ? update : get,
      values: {
        browser
      }
    }))));
  }

  render() {
    if (this.shouldNotShowbanner()) {
      return null;
    }

    external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logImpression('uxp.hyd.browser-deprecation-banner.banner.impression', {
      userAgent: _objectSpread({}, this.userAgent)
    });
    const props = this.props;
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("header", {
      role: "banner"
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('browser-deprecation-banner')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      tabIndex: 0,
      onClick: this.dismiss,
      className: this.namespace('banner-close')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: "uxicon uxicon-x"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", {
      className: this.namespace('browsers-message')
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('browsers-alert', 'uxicon', 'uxicon-alert'),
      "aria-hidden": "true"
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:BrowserDeprecationBanner:NewestBrowsers"
    })), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('browsers-list')
    }, this.renderBrowsers()))));
  }

}
/**
 * Allowed browser deprecation values.
 *
 * @enum {Object}
 * @api public
 */


banner_BrowserDeprecationBanner.propTypes = _objectSpread(_objectSpread({}, namespace_component_["NamespaceShape"]), {}, {
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  supportMatrix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  whitelistedUserAgents: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  disableDeprecationBanner: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  blacklistedBrowsers: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    browser: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
    version: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number
  }))
});
banner_BrowserDeprecationBanner.defaultProps = {
  disableDeprecationBanner: false,
  blacklistedBrowsers: []
};
/* harmony default export */ var banner = (Object(namespace_component_["withNamespace"])(banner_BrowserDeprecationBanner));
// CONCATENATED MODULE: ./node_modules/@ux/browser-deprecation-banner/src/index.js


function BannerLoader(props) {
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(banner, props);
}

/***/ })

}]);